import { useCallback } from "react";
import { BsFillFileEarmarkTextFill, BsGridFill, BsStarFill } from "react-icons/bs";
import { FaIdCard } from "react-icons/fa";
import { FaExchangeAlt, FaHandHoldingHeart, FaUserCircle } from "react-icons/fa";
import { IoBag } from "react-icons/io5";
import { MdInsertChart } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { onSetUser } from "../../../../redux/slices/user.slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { useUserEditMutation } from "../../../../utils/api/user/user.api";
import { getRoutePath } from "../../../routes/routes";
import { useActiveLink } from "../../admin/Layouts/SideBarAdmin/SideBarAdmin";
import "./Sidebar.css";

interface PropsType {
  index: number;
}

export const useSwitch = (bool: boolean) => {
  const user = useAppSelector((s) => s.user.user);
  const [update] = useUserEditMutation();
  const dispatch = useAppDispatch();

  const switchTo = useCallback((profil?: boolean) => {
    if (user) {
      const ok = profil === undefined ? bool : profil;
      dispatch(onSetUser({ ...user, is_double_type: ok }));
      update({ is_double_type: ok });
    }
  }, []);

  return switchTo;
};

const Sidebar = ({ index }: PropsType) => {
  const user = useAppSelector((s) => s.user.user);
  const switchTo = useSwitch(true);
  let links: any = [];
  if (!user?.is_double_type) {
    links = [
      {
        label: "Mes projets",
        pathname: getRoutePath("ListeProjets"),
        icon: <BsFillFileEarmarkTextFill />,
      },
      {
        label: "Mes dons",
        pathname: getRoutePath("MesDons"),
        icon: <FaHandHoldingHeart />,
      },
      {
        label: "Mes commandes",
        pathname: getRoutePath("MesCommandes"),
        icon: <IoBag />,
      },
      {
        label: "Mes points",
        pathname: getRoutePath("MesPoints"),
        icon: <BsStarFill />,
      },
      {
        label: "Mon identité",
        pathname: getRoutePath("VerificationIdentite"),
        icon: <FaIdCard />,
      },
      {
        label: "Mon Compte",
        pathname: getRoutePath("MonCompte"),
        icon: <FaUserCircle />,
        onClick: () => null,
      },
    ];
  } else {
    links = [
      {
        label: "Dashboard",
        pathname: getRoutePath("MerchantDashboard"),
        icon: <MdInsertChart />,
      },
      {
        label: "Mes offres",
        pathname: getRoutePath("ProductList"),
        icon: <BsGridFill />,
      },
      {
        label: "Mes commandes",
        pathname: getRoutePath("CommandeList"),
        icon: <IoBag />,
      },
      {
        label: "Mes points",
        pathname: getRoutePath("MesPointsCommercant"),
        icon: <BsStarFill />,
      },
      {
        label: "Mon Compte",
        pathname: getRoutePath("ParametreProfil"),
        icon: <FaUserCircle />,
        onClick: () => null,
      },
    ];
  }

  if (user?.is_commercant) {
    links.push({
      label: !user?.is_double_type
        ? "Profil commerçant"
        : "Profil investisseur",
      pathname: "#",
      icon: <FaExchangeAlt />,
      onClick: () => {
        switchTo(!user?.is_double_type);
        return null;
      },
    });
  }

  const active = useActiveLink(links, index);

  return (
    <div
      id="scrollbar-nav"
      className="col-xl-2 col-lg-3 col-md-4 px-0 tableau-de-bord-side-bar padding-responsive position-relative"
    >
      <div className="tdb-sidebar-panel">
        <ul className="tdb-sidebar-links">
          {links.map((link, index) => (
            <li
              className={`tdb-sidebar-item ${
                active === index ? "tdb-sidebar-item-active" : ""
              }`}
              key={index}
              onClick={() => {
                if (link.onClick) {
                  link.onClick();
                }
              }}
            >
              <Link
                to={link.pathname}
                className={`tdb-sidebar-link ${
                  active === index ? "tdb-sidebar-link-active" : ""
                }`}
              >
                <span className="tdb-sidebar-icon">{link.icon}</span>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
